import { Redirect } from 'expo-router';

export default function MessagesIndexRedirect() {

  return <Redirect href="/messages/inbox" />;
} 